import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['menu', 'arrow'];

  declare readonly menuTarget: HTMLElement;
  declare readonly arrowTarget: HTMLElement;

  clickOutsideListener: (event: MouseEvent) => void;
  keyDownListener: (event: KeyboardEvent) => void;

  connect() {
    this.clickOutsideListener = (event: MouseEvent) =>
      this.handleClickOutside(event);
    this.keyDownListener = (event: KeyboardEvent) => this.handleKeyDown(event);
  }

  disconnect() {
    this.removeGlobalListeners();
  }

  toggle(event: Event) {
    event.preventDefault();
    this.isOpen() ? this.close() : this.open();
  }

  open() {
    this.menuTarget.classList.add('open');
    this.arrowTarget.classList.add('open-up');

    document.addEventListener('click', this.clickOutsideListener);
    document.addEventListener('keydown', this.keyDownListener);
  }

  close() {
    this.menuTarget.classList.remove('open');
    this.arrowTarget.classList.remove('open-up');

    this.removeGlobalListeners();
  }

  isOpen(): boolean {
    return this.menuTarget.classList.contains('open');
  }

  handleClickOutside(event: MouseEvent) {
    if (!this.element.contains(event.target as Node)) {
      this.close();
    }
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.close();
    }
  }

  removeGlobalListeners() {
    document.removeEventListener('click', this.clickOutsideListener);
    document.removeEventListener('keydown', this.keyDownListener);
  }
}
